import update from "immutability-helper";
import { conf } from "../../conf/index";
import { StoreState } from "../root-reducer";
import {
	TableLinkTableAddedAction,
	TableLinkTableRemovedAction
} from "../../actions/store/type";

const getGroupIndexForTableId = (groups: string[][], id: string) => {
	return groups.reduce((acc, group, index) => {
		if (group.some(tableId => tableId === id)) {
			acc = index;
		}

		return acc;
	}, -1);
};

const removeTableFromGroup = (
	groups: string[][],
	existingGroupIndex: number,
	id: string
) => {
	const groupIdIndex = groups[existingGroupIndex].indexOf(id);

	groups = update(groups, {
		[existingGroupIndex]: {
			$splice: [[groupIdIndex, 1]]
		}
	});

	if (groups[existingGroupIndex].length === 0) {
		groups = update(groups, {
			$splice: [[existingGroupIndex, 1]]
		});
	}

	return groups;
};

export const handleTableLinkTableAdded = (
	state: StoreState,
	action: TableLinkTableAddedAction
) => {
	let updatedGroups = Array.from(state.tempTableLinkGroups);
	let existingGroupIndex = getGroupIndexForTableId(
		updatedGroups,
		action.payload.id
	);

	if (existingGroupIndex > -1 && state.tableLinkActiveGroup === -1) {
		// Set the active link group id if touching existing group first

		return {
			...state,
			tableLinkActiveGroup: existingGroupIndex
		};
	} else if (state.tableLinkActiveGroup > -1) {
		// Update group of table if active group is set

		let activeGroup = state.tableLinkActiveGroup;
		const groupLength = updatedGroups.length;

		if (
			updatedGroups[state.tableLinkActiveGroup].indexOf(
				action.payload.id
			) === -1
		) {
			updatedGroups[state.tableLinkActiveGroup] = update(
				updatedGroups[state.tableLinkActiveGroup],
				{
					$push: [action.payload.id]
				}
			);

			if (existingGroupIndex > -1) {
				updatedGroups = removeTableFromGroup(
					updatedGroups,
					existingGroupIndex,
					action.payload.id
				);

				if (activeGroup > 0 && updatedGroups.length < groupLength) {
					activeGroup--;
				}
			}
		}

		return {
			...state,
			tempTableLinkGroups: updatedGroups,
			tableLinkActiveGroup: activeGroup
		};
	} else {
		// Create a new group if a new table is touched and no active group has been set

		return {
			...state,
			tableLinkActiveGroup: state.tempTableLinkGroups.length,
			tempTableLinkGroups: update(updatedGroups, {
				$push: [[action.payload.id]]
			})
		};
	}
};

export const handleTableLinkTableRemoved = (
	state: StoreState,
	action: TableLinkTableRemovedAction
) => {
	let updatedGroups = [...state.tempTableLinkGroups];
	let existingGroupIndex = getGroupIndexForTableId(
		updatedGroups,
		action.payload.id
	);

	if (existingGroupIndex === -1) {
		return state;
	}

	updatedGroups = removeTableFromGroup(
		updatedGroups,
		existingGroupIndex,
		action.payload.id
	);

	return {
		...state,
		tempTableLinkGroups: updatedGroups
	};
};
